import { render, staticRenderFns } from "./MyTaskList.vue?vue&type=template&id=05b97f22&"
import script from "./MyTaskList.vue?vue&type=script&lang=js&"
export * from "./MyTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports